import React, { createContext, useContext, useEffect, useState } from "react";
import { login as apiLogin, me as apiMe } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=unknown, false=guest, {email,role}=admin
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("sibo_admin_token");
    if (!token) { setUser(false); setReady(true); return; }
    apiMe().then((u) => { setUser(u); setReady(true); }).catch(() => {
      localStorage.removeItem("sibo_admin_token");
      setUser(false); setReady(true);
    });
  }, []);

  const doLogin = async (email, password) => {
    const res = await apiLogin(email, password);
    localStorage.setItem("sibo_admin_token", res.token);
    setUser({ email: res.email, role: res.role });
    return res;
  };

  const logout = () => {
    localStorage.removeItem("sibo_admin_token");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, ready, login: doLogin, logout }}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  return useContext(AuthCtx);
}
